const baseConfig = {
  baseUrl: "https://core.varizi.ir/api/admin/",
  project: "admin",
  basUrlRaw: "https://core.varizi.ir/",
  appId: 100
}
export default baseConfig
